export type TextProps = {
    text?: string;
    bold?: boolean;
    italic?: boolean;
}

export function setTextProps(style: React.CSSProperties | undefined,
    bold: boolean | undefined, italic: boolean | undefined) {
    if (style == null) {
        style = {};
    }
    if (bold === true) {
        style.fontWeight = 700;
    }

    if (italic === true) {
        style.fontStyle = "italic";
    }
    return style;
}

export function setNormalWhiteSpace(props: any) {
    if (props.whiteSpace == null) {
        // https://developer.mozilla.org/en-US/docs/Web/CSS/white-space
        props.whiteSpace = "pre-wrap";// 預設顯示單純文字，包含 \n 換行 與 空格 (不會 render <br/> &nbsp;...)
    }
}